import { Component, Input, OnChanges, OnInit, SimpleChanges } from "@angular/core";

@Component({
	selector: "caass-batch-attendance-csv-preview-table",
	templateUrl: "./batch-attendance-csv-preview-table.component.html",
	styleUrls: ["./batch-attendance-csv-preview-table.component.css"],
})
export class BatchAttendanceCsvPreviewTableComponent implements OnInit, OnChanges {
	constructor() {}

	ngOnInit(): void {
		this.UpdateData();
	}

	ngOnChanges(changes: SimpleChanges): void {
		this.UpdateData();
	}

	/////////////////////////////////////////////////////////////////////////////////////////
	// Data
	/////////////////////////////////////////////////////////////////////////////////////////

	@Input() lstAttendance: any = [];
	@Input() TableLoading: any = false;

	pagerows: any = 10;
	pagefirst: any = 0;

	SelectedAttendance: any;

	//Filter lists
	lstSchoolName: any = [];
	lstOldAttendanceStatusDesc: any = [];
	lstNewAttendanceStatusDesc: any = [];
	lstOldExcuseDesc: any = [];
	lstNewExcuseDesc: any = [];
	lstIsValidDesc: any = [];

	//Cols
	cols: any = [
		{ field: "PersonName", header: "Name", CanEditStatus: false, CanEditTime: false },
		{ field: "RawStudentID", header: "Student ID", CanEditStatus: false, CanEditTime: false },
		{ field: "SchoolName", header: "School", CanEditStatus: false, CanEditTime: false },
		{ field: "RawEntryDate", header: "Attendance Date", CanEditStatus: false, CanEditTime: false },
		{ field: "OldAttendanceStatusDesc", header: "Old Status", CanEditStatus: false, CanEditTime: false },
		{ field: "NewAttendanceStatusDesc", header: "New Status", CanEditStatus: true, CanEditTime: false },
		{ field: "OldEntryTime", header: "Old Entry Time", CanEditStatus: false, CanEditTime: false },
		{ field: "NewEntryTime", header: "New Entry Time", CanEditStatus: false, CanEditTime: true },
		{ field: "OldExcuseDesc", header: "Old Excuse", CanEditStatus: false, CanEditTime: false },
		{ field: "NewExcuseDesc", header: "New Excuse", CanEditStatus: false, CanEditTime: false },
		{ field: "OldComments", header: "Old Comments", CanEditStatus: false, CanEditTime: false },
		{ field: "NewComments", header: "New Comments", CanEditStatus: false, CanEditTime: false },
		{ field: "IsValidDesc", header: "Valid?", CanEditStatus: false, CanEditTime: false },
	];

	lstAttendanceStatus: any = [
		{
			ID: 1,
			Desc: "Present",
			Code: "P",
		},
		{
			ID: 2,
			Desc: "Absent",
			Code: "A",
		},
		{
			ID: 3,
			Desc: "Tardy",
			Code: "T",
		},
	];

	/////////////////////////////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////////////////////////////
	// Load Data
	/////////////////////////////////////////////////////////////////////////////////////////

	UpdateData() {
		this.lstSchoolName = Array.from(new Set(this.lstAttendance.map((item: any) => item.SchoolName))).sort();
		this.lstOldAttendanceStatusDesc = Array.from(new Set(this.lstAttendance.map((item: any) => item.OldAttendanceStatusDesc))).sort();
		this.lstNewAttendanceStatusDesc = Array.from(new Set(this.lstAttendance.map((item: any) => item.NewAttendanceStatusDesc))).sort();
		this.lstOldExcuseDesc = Array.from(new Set(this.lstAttendance.map((item: any) => item.OldExcuseDesc))).sort();
		this.lstNewExcuseDesc = Array.from(new Set(this.lstAttendance.map((item: any) => item.NewExcuseDesc))).sort();
		this.lstIsValidDesc = Array.from(new Set(this.lstAttendance.map((item: any) => item.IsValidDesc))).sort();
	}

	/////////////////////////////////////////////////////////////////////////////////////////
}
